import React from 'react';

const ProfileAvatar = ({ photoUrl, name, size = 24, testId }) => {
  const initial = (name || '').trim().charAt(0).toUpperCase() || '?';

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        data-testid={testId}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: '50%',
          objectFit: 'cover',
          flexShrink: 0,
        }}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      data-testid={testId}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        backgroundColor: '#AE8890',
        color: '#51120A',
        fontFamily: "'Bricolage Grotesque', sans-serif",
        fontSize: `${Math.max(11, Math.round(size * 0.46))}px`,
        fontWeight: 600,
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {initial}
    </span>
  );
};

export default ProfileAvatar;